import { render, staticRenderFns } from "./VQuoteOfTheDay.vue?vue&type=template&id=8691a8e0&"
import script from "./VQuoteOfTheDay.vue?vue&type=script&lang=js&"
export * from "./VQuoteOfTheDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports